import classNames from 'classnames';
import { EmptyOrdersBasket } from 'components/Workspaces/OrdersBasket/FormTable/Empty/EmptyOrdersBasket';
import { useAppSelector } from 'hooks/useAppSelector';
import { FC, PropsWithChildren } from 'react';
import { getOrdersBasketFormIdsByProductVariation } from 'state/workspaces/ordersBasket/tabContent/tabContent.selectors';
import styled from 'styled-components';

export interface OrdersBasketFormTableProps {
  className?: string;
  productType: string;
  productSubType: string;
}

const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;

  td {
    padding: 0;
  }

  th {
    padding: 0 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  td,
  th {
    background: var(--bs-bg-lvl1);
    border: none;
    border-right: 1px solid var(--bs-border-color);
    border-bottom: 1px solid var(--bs-border-color);
  }

  td:last-child,
  th:last-child {
    border-right: none;
  }

  td:first-child,
  th:first-child {
    left: 0;
  }

  td:nth-child(2),
  th:nth-child(2) {
    left: 33.223px; /* Width of first column plus margins */
  }

  td:first-child,
  th:first-child,
  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    background: var(--bs-bg-lvl1);
    z-index: 2;
  }

  th:first-child {
    z-index: 5;
  }

  thead th {
    position: sticky;
    top: 0;
    background: var(--bs-bg-lvl1);
    z-index: 4;
  }

  thead th:first-child {
    left: 0;
    z-index: 10;
  }

  thead th:nth-child(2) {
    left: 33.223px;
    z-index: 10;
  }
`;

export const OrdersBasketFormTableNext: FC<PropsWithChildren<OrdersBasketFormTableProps>> = ({
  className,
  productType,
  productSubType,
  children,
}) => {
  const formIds = useAppSelector(state =>
    getOrdersBasketFormIdsByProductVariation(state, { productSubType, productType }),
  );

  if (formIds.length < 1) {
    return <EmptyOrdersBasket />;
  }

  return (
    <div className={classNames(className, 'overflow-auto')}>
      <div className="overflow-auto w-100 h-100 border">
        <StyledTable>{children}</StyledTable>
      </div>
    </div>
  );
};
